__turbopack_context__.v({
  "profileProjects": "zk7oDG_profileProjects",
});
